import { Button, Typography } from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import Box from '@material-ui/core/Box';
import Fade from '@material-ui/core/Fade';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Modal from '@material-ui/core/Modal';
import Select from '@material-ui/core/Select';
import AddToPhotosIcon from '@material-ui/icons/AddToPhotos';
import GradientIcon from '@material-ui/icons/Gradient';
import PauseCircleFilledIcon from '@material-ui/icons/PauseCircleFilled';
import VideocamIcon from '@material-ui/icons/Videocam';
import StreamOfflinePanel from '../StreamOfflinePanel';
import useStyles from './StreamController.style.js';
import React from 'react';
import has from 'lodash/has';
import { useSelector } from 'react-redux';
import { switchInput } from 'utils/apiCalls';
import { v4 as uuid } from 'uuid';

const StreamController = () => {
  const classes = useStyles();
  const { SessionId, Videos, ResourceId, ResourceStatus, status, userRole, Standby } = useSelector(
    ({ conference, user }) => ({
      SessionId: conference.SessionId,
      ResourceId: conference.ResourceId,
      Videos: conference.Videos,
      status: conference.Status,
      ResourceStatus: conference.ResourceStatus,
      userRole: user.role,
      Standby: conference.Standby,
    })
  );
  const [open, setOpen] = React.useState(false);
  const [nextInput, setNextInput] = React.useState('');

  if (status !== 'LIVE') return <StreamOfflinePanel status={status} userRole={userRole} />;

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const switchTo = (type, path) => {
    switch (type) {
      case 'chime':
        switchInput(SessionId, ResourceId, {
          Type: 'Static',
          ActionName: `switch-chime-${uuid()}`,
          InputAttachmentName: 'ChimeInput',
        });
        break;
      case 'loop':
        switchInput(SessionId, ResourceId, {
          Type: 'Dynamic',
          ActionName: `switch-loop-${uuid()}`,
          S3Path: path,
          InputAttachmentName: 'LoopInput',
        });
        break;
      case 'continue':
        switchInput(SessionId, ResourceId, {
          Type: 'Dynamic',
          ActionName: `switch-continue-${uuid()}`,
          S3Path: path,
          InputAttachmentName: 'ContinueInput',
        });
        break;
      default:
    }
  };

  const switchToNext = () => {
    if (nextInput === 'chime') {
      switchTo('chime', '', true);
    } else {
      switchTo('continue', nextInput, true);
    }
    setNextInput('');
  };

  return (
    <div className={classes.root}>
      <Box display="flex" flexDirection="column" justifyContent="center">
        <div className={classes.imgTitle}>Active</div>
        <div className={classes.imgContainer}>
          <img
            className={classes.images}
            src="https://cnet1.cbsistatic.com/img/a2F9eyxfV0VTBygHIHDAz-dyMa0=/940x0/2020/04/02/af2fb84e-8330-41a0-b090-db0036c1ae6d/messenger-desktop-group-video-call.png"
            alt="Current Video"
          />
          <div className={classes.imgOverlay}>
            <Typography>{ResourceStatus.CurrentInput}</Typography>
          </div>
        </div>

        <Button
          disabled={nextInput === ''}
          color="primary"
          className={classes.nextbutton}
          variant="contained"
          onClick={() => switchToNext()}
        >
          <GradientIcon />
          <Typography className={classes.buttonText}>Next</Typography>
        </Button>

        {nextInput !== '' ? (
          <>
            <div className={classes.imgTitleQueue}>Queued</div>
            <div className={classes.imgContainer}>
              <img
                className={classes.images}
                onClick={handleOpen}
                src="https://cnet1.cbsistatic.com/img/a2F9eyxfV0VTBygHIHDAz-dyMa0=/940x0/2020/04/02/af2fb84e-8330-41a0-b090-db0036c1ae6d/messenger-desktop-group-video-call.png"
                alt="Next Video"
              />
              <div className={classes.imgOverlay}>{nextInput.split('/')?.[3]}</div>
              <div className={classes.clearButtonOverlay}>
                <Button onClick={() => setNextInput('')}>Clear</Button>
              </div>
            </div>
          </>
        ) : (
          <div className={classes.selectNextBox}>
            <Button
              onClick={() => setNextInput('chime')}
              color="primary"
              className={classes.nextbutton}
              type="button"
              variant="contained"
              style={{
                margin: '0px auto',
                width: '75%',
                marginBottom: '20px',
              }}
            >
              <VideocamIcon />
              <Typography className={classes.buttonText}>Queue Presenters</Typography>
            </Button>
            <Button
              onClick={handleOpen}
              color="primary"
              className={classes.nextbutton}
              type="button"
              variant="contained"
              style={{
                margin: '0px auto',
                width: '75%',
                marginBottom: '20px',
              }}
            >
              <AddToPhotosIcon />
              <Typography className={classes.buttonText}>Queue Media</Typography>
            </Button>
          </div>
        )}

        <Button
          className={classes.standbyButton}
          variant="contained"
          onClick={() => {
            if (has(Standby, 'Bucket') && has(Standby, 'Key')) {
              switchTo('loop', `${Standby.Bucket}/${Standby.Key}`, true);
            } else {
              switchTo('loop', `mosaic-chime-broadcast-conference/Standby.mp4`, true);
            }
          }}
        >
          <PauseCircleFilledIcon />
          <Typography className={classes.buttonText}>Standby</Typography>
        </Button>
      </Box>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <InputLabel shrink id="video-select-placeholder">
              Uploaded Videos
            </InputLabel>
            <Select
              native
              fullWidth
              value={nextInput}
              onChange={(e) => {
                setNextInput(e.target.value);
                handleClose();
              }}
            >
              <option value={''} />
              {Videos.map((video) => {
                return (
                  <option key={video.Key} value={`${video.Bucket}/${video.Key}`}>
                    {video.Name}
                  </option>
                );
              })}
            </Select>
            <FormHelperText>{`Video will not play until "NEXT" is selected`}</FormHelperText>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

export default StreamController;
